import { useQuery } from "@tanstack/react-query";
import { algod } from "@/lib/algo";
import { modelsv2 } from "algosdk";
import { FirstArg } from "@/lib/types";
import { getBalanceFromAccountInfo } from "@/lib/utils";
import { queryClient } from "@/lib/query-client";

const queryKeyPrefix = ["algoaccountinfo"];

export const useAlgoAcctInfo = (account?: string) => {
  return useQuery({
    queryKey: [queryKeyPrefix, account ?? ""],
    gcTime: 60 * 1_000,
    staleTime: 60 * 1_000,
    queryFn: async (): Promise<modelsv2.Account | null> => {
      if (!account) return null;
      const acct = (await algod
        .accountInformation(account)
        .do()) as FirstArg<typeof modelsv2.Account.from_obj_for_encoding>;
      return modelsv2.Account.from_obj_for_encoding(acct);
    },
  });
};

export const useBalance = (
  assetId: number | bigint,
  accountInformation?: modelsv2.Account | null
) => {
  assetId = Number(assetId);
  if (!accountInformation) return -2;
  if (assetId === 0) return Number(accountInformation.amount);
  if (assetId === 1)
    return (
      Math.max(0, Number(accountInformation.amount) - Number(accountInformation.minBalance))
    );
  return getBalanceFromAccountInfo(assetId, accountInformation);
};


export const clearAlgoAcctInfoCache = () => {
  queryClient.invalidateQueries({ queryKey: queryKeyPrefix });
};
